import { Box } from '@mui/material';

import { useFindAllAktivFakturierbarAufwandMonthQuery } from '../../aufwand/api/aufwandApi';
import { FakturierbareAufwaendeTacho } from '../DashboardAufwandTacho';

export const TachoMonat = () => {
  const getDaysInMonth = (year: number, month: number) => new Date(year, month, 0).getDate();
  const date = new Date();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const monthName = date.toLocaleString('default', { month: 'long' });
  const daysInMonth = getDaysInMonth(year, month);
  const day = date.getDate();

  const { data } = useFindAllAktivFakturierbarAufwandMonthQuery();

  const daten = data?.map(
    ({
      mitarbeiter_nachname,
      mitarbeiter_role,
      mitarbeiter_vorname,
      mitarbeiter_monatsarbeitsstunden,
      sum,
    }) => ({
      name: `${mitarbeiter_vorname} ${mitarbeiter_nachname} (${mitarbeiter_role})`,
      value: Math.round(sum / 36000 / (mitarbeiter_monatsarbeitsstunden * (day / daysInMonth))),
    })
  );

  if (daten?.length === 0) {
    return (
      <div className="align-center ">
        <h2 style={{ marginBottom: '8px', textAlign: 'center' }}>
          {monthName} {year} ({daysInMonth} Tage)
        </h2>
        <p style={{ marginBottom: '8px', textAlign: 'center' }}>
          Es gibt im Betrachtungszeitraum noch keine Daten
        </p>
        <svg xmlns="http://www.w3.org/2000/svg" width="1350" height="200" viewBox="0 0 1200 700">
          <rect width="1200" height="700" fill="#ffffff" />
          <g
            fill="none"
            stroke="#5C7EA6"
            strokeWidth="22"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M280 510 A320 320 0 0 1 920 510" />
            <line x1="280" y1="510" x2="470" y2="510" />
            <line x1="730" y1="510" x2="920" y2="510" />

            <line x1="470" y1="335" x2="490" y2="365" />
            <line x1="600" y1="295" x2="600" y2="335" />
            <line x1="730" y1="335" x2="710" y2="365" />

            <circle cx="600" cy="510" r="32" />
            <line x1="600" y1="510" x2="600" y2="390" />

            <line x1="250" y1="630" x2="970" y2="190" />
          </g>
        </svg>
      </div>
    );
  }
  return (
    <>
      <h2 style={{ marginBottom: '-50px' }}>
        {monthName} {year} ({daysInMonth} Tage)
      </h2>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        {daten?.map((chartData, chartNumber) => (
          <FakturierbareAufwaendeTacho chartData={chartData} key={chartNumber} />
        ))}
      </Box>
    </>
  );
};
